import React from 'react';

import { Button, Modal, Typography } from 'antd';

import CloseModal from '../../assets/svg/CloseModal';
import './styles.scss';

interface Props {
  title?: string;
  showModal: boolean;
  closeModal: () => void;
  url: string;
}

const modalMaskStyle: React.CSSProperties = {
  backgroundColor: 'rgba(244, 244, 244, 0.8)',
};

const IframeViewer: React.FC<Props> = ({
  title = 'External Content',
  showModal,
  closeModal,
  url,
}) => {
  const handleOpenInNewTab = () => {
    window.open(url, '_blank');
    closeModal();
  };

  const handleModalClose = () => {
    closeModal();
  };

  return (
    <Modal
      title={
        <Typography.Title
          ellipsis={{
            rows: 1,
            expandable: false,
          }}
          level={4}
          className="title"
          style={{ textAlign: 'left' }}>
          {title}
        </Typography.Title>
      }
      open={showModal}
      onOk={handleModalClose}
      onCancel={handleModalClose}
      wrapClassName="iframeViewerModal"
      maskStyle={modalMaskStyle}
      centered
      destroyOnClose={true}
      closeIcon={<CloseModal />}
      footer={
        <div style={{ textAlign: 'center', padding: '8px 0' }}>
          <Button type="primary" onClick={handleOpenInNewTab}>
            Open in New Tab
          </Button>
        </div>
      }
      style={{
        margin: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        maxWidth: '100%',
      }}
      bodyStyle={{
        height: '80vh',
        padding: 0,
        borderRadius: 0,
        overflow: 'auto',
      }}>
      {showModal && url ? (
        <iframe
          src={url}
          title={title}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          allow="microphone; clipboard-write; camera; geolocation; payment; autoplay; fullscreen; display-capture"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-top-navigation allow-top-navigation-by-user-activation allow-presentation allow-modals allow-orientation-lock allow-pointer-lock allow-popups-to-escape-sandbox"
        />
      ) : null}
    </Modal>
  );
};

export default IframeViewer;
